import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Nav, NavItem, Input} from 'react-bootstrap';
import './search-box.scss';
import { Translate } from './../../common/translator.js';

export default class SimpleSearch extends Component{
  _inputChanged(e) {
    this.props.onSearchChanged(e.target.value);
  }

  _onItemSelected(navIdx) {
    this.props.onItemSelected(navIdx);
    this.props.onSearchResultSelected(this.props.searchResults[navIdx].idPlant);
  }

  _onNavChange(navIdx) {
    this.props.onNavIndexChanged(navIdx);
  }

  _onInputBoxFocus() {
    this.props.onSetShowSearchResults(true);
  }

  _onInputBoxBlur() {
    if (this.props.isPointerInsideNavBox) {
      return;
    }

    this.props.onSetShowSearchResults(false);
  }

  _onNavMouseEnter() {
    this.props.onSetPointerInsideNavBox(true);
  }

  _onNavMouseLeave() {
    this.props.onSetPointerInsideNavBox(false);
  }

  _onKeyDown(e) {
    const {
      nSelectedNavIndex,
      searchResults,
      onSetPointerInsideNavBox,
      onSetShowSearchResults
    } = this.props;
    let tmpIdx = 0;
    switch (e.key) {
      case 'ArrowDown':
        tmpIdx = nSelectedNavIndex + 1;
        if (searchResults.length > tmpIdx) {
          this._onNavChange(tmpIdx);
        }

        e.preventDefault();
        break;
      case 'ArrowUp':
        tmpIdx = nSelectedNavIndex - 1;
        if (0 <= tmpIdx) {
          this._onNavChange(tmpIdx);
        }

        e.preventDefault();
        break;
      case 'Enter':
        this._blurInputBox();
        this._onItemSelected(nSelectedNavIndex);
        e.preventDefault();
        break;
      case 'Escape':
        this._blurInputBox();
        onSetPointerInsideNavBox(false);
        onSetShowSearchResults(false);
        e.preventDefault();
        break;
      default:
        break;
    }
  }

  _blurInputBox() {
    const inputBoxNode = ReactDOM.findDOMNode(this.refs.SokInputBox);
    const childNode = inputBoxNode.childNodes[0];
    childNode.blur();
  }

  _onItemMouseDown(e) {
    if (this.props.isMobilePhone) {
      this._onItemSelected(parseInt(e.currentTarget.dataset.navIndex));
    }
  }

  _getHTMLSearchResults() {
    const {
      searchResults,
      searchWord,
      isShowSearchResults,
      nSelectedNavIndex,
      isDataLoading
      } = this.props;

    let searchResultsHTML = null;

    if ((searchWord && searchWord.length > 0) &&
      isShowSearchResults && isDataLoading) {
      searchResultsHTML = (
          <div className='loading-container'>
            <i className='fa fa-3x fa-spinner fa-pulse'></i>
          </div>
        );
    } else if ((searchWord && searchWord.length > 0) &&
        (searchResults && searchResults.length > 0) &&
        isShowSearchResults) {
      let items = searchResults.map((elem, i) => {
        return (
          <NavItem eventKey={i}
                   key={i}
                   data-nav-index={i}
                   onMouseDown={this._onItemMouseDown.bind(this)}>
            {elem.name}
          </NavItem>
        );
      });
      if (items && this.props.isMobilePhone) {
        items = items.slice(0, 5);
      }

      searchResultsHTML = (
        <Nav bsStyle='pills'
             stacked
             activeKey={nSelectedNavIndex}
             onSelect={this._onItemSelected.bind(this)}
             onMouseLeave={this._onNavMouseLeave.bind(this)}
             onMouseEnter={this._onNavMouseEnter.bind(this)}>
          {items}
        </Nav>
      );
    } else if ((searchWord && searchWord.length > 0) &&
        (searchResults && searchResults.length === 0) &&
        isShowSearchResults) {
      searchResultsHTML = (
        <Nav bsStyle='pills'
             stacked
             activeKey={nSelectedNavIndex}
             onSelect={this._onItemSelected.bind(this)}
             onMouseLeave={this._onNavMouseLeave.bind(this)}
             onMouseEnter={this._onNavMouseEnter.bind(this)}>
          <NavItem eventKey={0} key={0}>
            {Translate('NoSearchResults')}
          </NavItem>
        </Nav>
      );
    } else {
      searchResultsHTML = null;
    }

    return searchResultsHTML;
  }

  render() {
    const {
      searchWord
      } = this.props;

    return (
      <div>
        <Input type='text'
               placeholder={Translate('typeToSearch')}
               onChange={this._inputChanged.bind(this)}
               onKeyDown={this._onKeyDown.bind(this)}
               onFocus={this._onInputBoxFocus.bind(this)}
               onBlur={this._onInputBoxBlur.bind(this)}
               value={searchWord}
               ref='SokInputBox'
               label={null}
               className='search-input'
          />
        <div className='search-box'>
          {this._getHTMLSearchResults()}
        </div>
      </div>
    );
  }
}

SimpleSearch.propTypes = {
  onSearchResultSelected: React.PropTypes.func.isRequired,
  onSearchChanged: React.PropTypes.func.isRequired,
  onSetPointerInsideNavBox: React.PropTypes.func.isRequired,
  onSetShowSearchResults: React.PropTypes.func.isRequired,
  onNavIndexChanged: React.PropTypes.func.isRequired,
  onItemSelected: React.PropTypes.func.isRequired,
  searchResults: React.PropTypes.array.isRequired,
  searchWord: React.PropTypes.string.isRequired,
  nSelectedNavIndex: React.PropTypes.number.isRequired,
  isPointerInsideNavBox: React.PropTypes.bool.isRequired,
  isDataLoading: React.PropTypes.bool.isRequired,
  isMobilePhone: React.PropTypes.bool.isRequired
};



/** WEBPACK FOOTER **
 ** app/components/search-box/view/search-box.js
 **/